import React from "react";
import styled from "styled-components";
import { colors2 } from "oolib";
import { UI_CAPTION_DF } from "oolib/dist/v2/components/Typo2";

/**
 * The pill switch this page uses everywhere a view toggles: the Layout
 * switch in the sidebar, Sub-topics / Topics above the cards, and
 * Priorities / Wins above the list — same look, one component.
 */

const Pills = styled.div`
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  border-radius: 6px;
  background: ${colors2.grey5};
`;

const Pill = styled.button`
  border: none;
  border-radius: 5px;
  padding: 4px 12px;
  cursor: pointer;
  white-space: nowrap;
  background: ${({ $active }) => ($active ? colors2.white : "transparent")};
  box-shadow: ${({ $active }) => ($active ? `0 1px 2px ${colors2.grey15}` : "none")};
`;

/**
 * @param {Array<{ value: string, display: string }>} options
 * @param {string} value
 * @param {(value: string) => void} onChange
 */
export const PillSwitch = ({ options = [], value, onChange, style }) => (
  <Pills style={style}>
    {options.map((opt) => (
      <Pill key={opt.value} type="button" $active={value === opt.value} onClick={() => onChange(opt.value)}>
        <UI_CAPTION_DF style={{ color: value === opt.value ? colors2.grey80 : colors2.grey60 }}>{opt.display}</UI_CAPTION_DF>
      </Pill>
    ))}
  </Pills>
);
